// CognitiveSpaceAdapter — future interface, mock localStorage implementation.
// Build 1 only persists reflections/insights locally. No external AI memory.

export interface Insight {
  id: string;
  text: string;
  dateISO: string;
  songId?: string;
  timestamp?: number;
}

const REFLECTION_KEY = "adaptivejam.reflections";
const INSIGHT_KEY = "adaptivejam.insights";

function read<T>(key: string): T[] {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T[]) : [];
  } catch {
    return [];
  }
}

function write<T>(key: string, val: T[]): void {
  localStorage.setItem(key, JSON.stringify(val));
}

function uid(prefix: string): string {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
}

export const CognitiveSpaceAdapter = {
  saveReflection(text: string, songId?: string): Insight {
    const list = read<Insight>(REFLECTION_KEY);
    const entry: Insight = { id: uid("ref"), text, dateISO: new Date().toISOString(), songId };
    list.push(entry);
    write(REFLECTION_KEY, list);
    return entry;
  },

  getReflections(): Insight[] {
    return read<Insight>(REFLECTION_KEY).reverse();
  },

  addInsight(text: string): Insight {
    const list = read<Insight>(INSIGHT_KEY);
    const entry: Insight = { id: uid("ins"), text, dateISO: new Date().toISOString() };
    list.push(entry);
    write(INSIGHT_KEY, list);
    return entry;
  },

  getPlayerInsights(): Insight[] {
    return read<Insight>(INSIGHT_KEY).reverse();
  },

  attachInsightToSong(insightId: string, songId: string): void {
    const list = read<Insight>(INSIGHT_KEY);
    const i = list.find((x) => x.id === insightId);
    if (i) {
      i.songId = songId;
      write(INSIGHT_KEY, list);
    }
  },

  attachInsightToTimestamp(insightId: string, timestamp: number): void {
    const list = read<Insight>(INSIGHT_KEY);
    const i = list.find((x) => x.id === insightId);
    if (i) {
      i.timestamp = timestamp;
      write(INSIGHT_KEY, list);
    }
  },
};
